import * as Yup from "yup";
import { parseCurrencyString } from "@/utils/parseCurrencyString";

export const serviceSchema = Yup.object().shape({
  category_id: Yup.mixed().nullable(),
  subscription_id: Yup.mixed().nullable(),

  name: Yup.string().required("Nome é obrigatório"),
  // A validação `unique` no backend, não dá para fazer no Yup, apenas na API

  description: Yup.string().nullable(),

  return_days: Yup.number()
    .transform((value, originalValue) => {
      return originalValue === "" || originalValue === undefined ? null : value;
    })
    .integer("Deve ser um número inteiro")
    .nullable(),

  display_in_agenda: Yup.boolean().required("Exibição na agenda é obrigatória"),

  subscriber_discount: Yup.string()
    .transform((value) => {
      if (typeof value === "string") {
        return value.replace(/[^\d.,]/g, "").replace(",", ".");
      }
      return value;
    })
    .nullable(),

  allow_price_change: Yup.boolean().required(
    "Permitir alteração de preço é obrigatório",
  ),

  price: Yup.string()
    .transform(parseCurrencyString)
    .test(
      "is-required",
      "Preço de compra é obrigatório",
      (value) => !!value && value !== "0" && value !== "0.00",
    )
    .test("is-valid", "Preço de compra deve ser maior que zero", (value) => {
      const numberValue = parseFloat(value ?? "0");
      return !isNaN(numberValue) && numberValue > 0;
    }),

  commission: Yup.string()
    .transform((value) => {
      if (typeof value === "string") {
        return value.replace(/[^\d.,]/g, "").replace(",", ".");
      }
      return value;
    })
    .required("Comissão é obrigatória")
    .test(
      "is-valid",
      "Comissão deve ser um número válido maior ou igual a zero",
      (value) => {
        if (!value) return false;
        const num = parseFloat(value);
        return !isNaN(num) && num >= 0;
      },
    ),

  time: Yup.string()
    .required("Tempo é obrigatório")
    .test("not-empty", "Tempo é obrigatório", (value) => {
      if (!value) return false;
      return value.trim() !== "";
    }),

  // string_time: Yup.string()
  // .required('Tempo em texto é obrigatório'),

  active: Yup.boolean().required("Status ativo é obrigatório"),

  // points: Yup.mixed()
  // .required('Pontos são obrigatórios'),

  //   image: Yup.mixed()
  //     .nullable()
  //     .test(
  //       'fileType',
  //       'Formato de imagem inválido. Apenas jpeg, png, jpg ou svg são permitidos.',
  //       (value) => {
  //         if (!value) return true; // Se não tiver imagem, ok
  //         const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/svg+xml'];
  //         return allowedTypes.includes(value.type);
  //       }
  //     )
  //     .test(
  //       'fileSize',
  //       'O tamanho máximo da imagem é 2MB.',
  //       (value) => {
  //         if (!value) return true;
  //         return value.size <= 2 * 1024 * 1024; // 2MB
  //       }
  //     )
});
